<template>
  <b-modal
    :active.sync="isModalActive"
    has-modal-card
    trap-focus
    aria-modal
    :width="480"
    @close="handleCloseModal"
  >
    <div class="card">
      <header class="card-header">
        <p class="card-header-title is-inline has-text-centered">
          Hold on!
        </p>
      </header>
      <div class="card-content u-p-y-0 has-text-centered">
        <b-icon icon="alert-octagon" size="is-large" type="is-danger" />
      </div>
      <div class="card-content u-p-t-small">
        <p>
          Are you sure you want to archive
          <span class="is-italic">{{ shapeUserDisplayName(activeUser) }}</span>?
        </p>
        <br />
        <p>
          This user will no longer be able to log into the {{ activeWorkspace.workspaceName }}
          workspace, and their past goals will not be visible to their former teammates.
        </p>
        <br />
        <small class="has-text-grey is-italic is-size-7">
          * Goal data for archived users is not deleted, and can be retrieved by
          the StandupPro support team upon request.
        </small>
      </div>
      <footer class="card-footer u-p-a">
        <div class="buttons">
          <b-button
            type="is-text"
            class="has-text-grey confirm-archive__footer__cancel"
            @click.prevent="handleCloseModal"
          >
            Cancel
          </b-button>
          <b-button
            type="is-danger"
            @click="handleClickArchiveUser"
            :loading="isUserArchiveInProgress"
          >
            Yes, Archive {{ shapeUserDisplayName(activeUser) }}
          </b-button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as UserActions from '@/store/actions/User.actions';
import * as NotificationService from '@/services/Notification.service';
import * as notificationTypes from '@/constants/notificationTypes';
import { shapeUserDisplayName } from '@/helpers/userHelpers';
import { getUserTeams } from '@/helpers/teamHelpers';

export default {
  name: 'ConfirmArchiveUserModal',

  props: {
    activeUserId: {
      type: String,
      required: true,
    },
    isModalActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isUserArchiveInProgress: false,
    };
  },

  computed: {
    ...mapState({
      users: state => state.user.users,
      teams: state => state.team.teams,
    }),
    ...mapGetters([
      'activeWorkspace',
    ]),
    activeUser() {
      return this.users[this.activeUserId];
    },
  },

  methods: {
    ...mapActions({
      archiveUser: UserActions.ARCHIVE_USER,
    }),
    handleClickArchiveUser() {
      this.isUserArchiveInProgress = true;

      this.archiveUser({
        userId: this.activeUserId,
        teamIds: this.getUserTeams(this.activeUserId, this.teams).map(team => team.id),
        workspaceId: this.activeWorkspace.id,
      })
        .then(() => { this.$emit('userArchived'); })
        .catch(() => {
          this.isUserArchiveInProgress = false;
          NotificationService.showNotification(notificationTypes.ARCHIVE_USER_ERROR);
        });
    },
    handleCloseModal() {
      this.$emit('close');
    },
    shapeUserDisplayName,
    getUserTeams,
  },
};
</script>

<style lang="scss" scoped>
.card-footer {
  justify-content: flex-end;
}

.confirm-archive__footer__cancel {
  text-decoration: none;
}
</style>
